const MessageFailedReason: {
  [key: string]: string;
} = {
  default: "There was an error sending your message. Please try again later.",
};

export default MessageFailedReason;
